import api from 'api';
import { updateUserBrandSuccess, addUserBrandSuccess } from 'actions/user-brands';

export const BRAND_ASYNC_ACTION_START = 'BRAND_ASYNC_ACTION_START';
export const BRAND_ASYNC_ACTION_ERROR = 'BRAND_ASYNC_ACTION_ERROR';
export const BRAND_ASYNC_UPDATE_SUCCESS = 'BRAND_ASYNC_UPDATE_SUCCESS';
export const BRAND_UPDATE_SUCCESS = 'BRAND_UPDATE_SUCCESS';
export const BRAND_RESET_STATE = 'BRAND_RESET_STATE';

function brandAsyncStart() {
  return {
    type: BRAND_ASYNC_ACTION_START,
  };
}

function brandUpdatAsyncSuccess(data) {
  return {
    type: BRAND_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function brandAsyncError(error) {
  return {
    type: BRAND_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetBrandState() {
  return {
    type: BRAND_RESET_STATE,
  };
}

export function updateBrand(data) {
  return {
    type: BRAND_UPDATE_SUCCESS,
    data,
  };
}

export function createBrandAsync(brand) {
  return (dispatch, getState) => {
    dispatch(brandAsyncStart());
    return api.request('brand', 'post', brand, api.contentTypes.form)
    .then((data) => {
      dispatch(brandUpdatAsyncSuccess(data));
      dispatch(addUserBrandSuccess(data));
    })
    .catch((err) => {
      dispatch(brandAsyncError('Unable to create brand'));
      throw (err);
    });
  };
}

export function updateBrandAsync(brand) {
  return (dispatch, getState) => {
    dispatch(brandAsyncStart());
    return api.request('brand', 'put', brand, api.contentTypes.form)
    .then((data) => {
      dispatch(brandUpdatAsyncSuccess(data));
      dispatch(updateUserBrandSuccess(data));
    })
    .catch((err) => {
      dispatch(brandAsyncError('Unable to create brand'));
      throw (err);
    });
  };
}

export function getBrandAsync(id) {
  return (dispatch, getState) => {
    dispatch(brandAsyncStart());
    return api.request(`brand/${ id }`, 'get')
    .then((data) => {
      dispatch(brandUpdatAsyncSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(brandAsyncError('Unable to get a brand'));
      throw (err);
    });
  };
}
